import React from 'react';
import { PlayButton as RobloxPlayButton } from 'Roblox';
import metadataConstants from '../constants/metadataConstants';
import sessionStorageUtils from '../../common/utils/sessionStorageUtils';
import eventStreamConstants, {
  sessionStorageKey
} from '../../common/constants/eventStreamConstants';
import usePageReferralTracker from '../../common/hooks/usePageReferralTracker';

const { usePlayabilityStatus, DefaultPlayButton } = RobloxPlayButton;

export default function PlayButton(): JSX.Element {
  const { universeId = '', rootPlaceId = '' } = metadataConstants.metadataData() || {};
  const [playabilityStatus, refetchPlayabilityStatus] = usePlayabilityStatus(universeId);

  usePageReferralTracker(
    eventStreamConstants.gameDetailReferral,
    [
      'isAd',
      'page',
      'placeId',
      'position',
      'gameSetTargetId',
      'homePageSessionInfo',
      'gameSearchSessionInfo',
      'numberOfLoadedTiles'
    ],
    ['privateServerLinkCode']
  );

  return (
    <DefaultPlayButton
      placeId={rootPlaceId}
      universeId={universeId}
      refetchPlayabilityStatus={refetchPlayabilityStatus}
      playabilityStatus={playabilityStatus}
      eventProperties={{
        ...sessionStorageUtils.getPerTabEventProperties([sessionStorageKey.homePageSessionInfo])
      }}
    />
  );
}
